module.exports = __webpack_public_path__ + "99577447a7e83c95635b8415c5c82bc6.svg";